
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.125 5.625h-1.938v.937h1.938v-.937z"}}),_c('path',{attrs:{"d":"M6.07 3.75C5.068 2.744 3.82 1.622 2.66.836c-.503-.34-.935-.58-1.286-.71C.86-.069.471-.038.217.215-.036.47-.067.86.126 1.375c.131.35.37.782.71 1.285.233.343.506.71.812 1.09H0V16h16V3.75H6.07zm.57 1.976c.744.845 1.352 1.64 1.733 2.277a1.498 1.498 0 00-.37.37c-.636-.382-1.432-.989-2.276-1.734l.913-.913zM.98.981c.226.074.662.275 1.42.817.89.637 1.939 1.547 2.954 2.562.224.224.442.45.653.673l-.975.974a31.1 31.1 0 01-.673-.653C3.345 4.34 2.435 3.29 1.798 2.4 1.257 1.642 1.055 1.206.981.98zM.938 4.687h1.504c.39.438.811.886 1.255 1.33A30.673 30.673 0 005.285 7.5H.937V4.687zm14.124 10.375H.938V8.437h5.5c.474.356.912.65 1.297.864.015.51.254 1.008.603 1.357.582.581 2.318.82 2.66.863l.596.073-.073-.596c-.04-.324-.257-1.902-.775-2.56h4.316v6.624zM8.835 8.834c.307-.306.854-.14 1.16.166.18.18.371.827.498 1.492-.666-.127-1.313-.318-1.492-.497-.308-.308-.472-.855-.166-1.16zM15.062 7.5H9.165c-.48-.796-1.25-1.78-2.198-2.813h8.095V7.5z"}}),_c('path',{attrs:{"d":"M11.25 5.625H9.375v.937h1.875v-.937z"}})])
          )
        }
      }
    